/* eslint-disable react/jsx-no-bind */
// @flow
import * as React from 'react';

import { rankWith, uiTypeIs } from '@jsonforms/core';

import CountryDialCodeInput from '../components/CountryDialCodeInput';
import useControlProps from '../util/useControlProps';

export const CountryDialCodeControl = (props: Props): React.Node => {
    const {
        path,
        data,
        handleChange,
        visible,
        enabled,
        required,
        label
    } = useControlProps(props);

    return (
        visible && (
            <CountryDialCodeInput
                value={data}
                required={required}
                label={label}
                disabled={!enabled}
                onChange={value => handleChange(path, value)}
            />
        )
    );
};

export default CountryDialCodeControl;

export const countryDialCodeControlTester = rankWith(
    1000,
    uiTypeIs('CountryDialCodeControl')
);
